import { render, staticRenderFns } from "./EmailSentPage.vue?vue&type=template&id=5f01c87a&scoped=true&"
import script from "./EmailSentPage.vue?vue&type=script&lang=js&"
export * from "./EmailSentPage.vue?vue&type=script&lang=js&"
import style0 from "./EmailSentPage.vue?vue&type=style&index=0&id=5f01c87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f01c87a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
